/*
 * File: SocialEngagement.tsx
 * Project: a-a
 * File Created: Monday, 6th January 2025 7:47:03 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 4th August 2025 9:36:42 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
/*
 * File: Account.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 9:48:32 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 6th January 2025 7:19:37 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import InfiniteScrollColumn from '../../InfiniteScrollColumn/InfiniteScrollColumn';
import { Box, Typography } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';

import { DashboardService } from '../../../../service/dashboard.service';
import { Link } from 'react-router-dom';
import SocialEngagementCard from './SocialEngagementCard/SocialEngagementCard';
import styles from './SocialEngagement.module.css';
const SocialEngagement = ({
  setTabLoading,
  creatorInfo,
  setValue,
  captive8Url,
  captive8loading,
}: {
  setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
  creatorInfo?: any;
  setValue?: React.Dispatch<React.SetStateAction<number>>;
  captive8Url?: any;
  captive8loading?: boolean;
}) => {
  console.log({ creatorInfo, captive8Url, setValue, captive8loading });
  const noData = creatorInfo && !Object.keys(creatorInfo)?.length;
  const Header = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '48px',
        }}
      >
        <Typography variant='responsiveHeading3'>Social Engagement</Typography>
        <Link
          to={captive8Url || 'https://captiv8.io/insights/signin'}
          style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
          target='_blank'
          rel='noopener noreferrer'
        >
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: { xs: '8px 8px 8px 14px', xl: '10px 10px 10px 16px' },
              backgroundColor: zeplinColor.Neutral1,
              border: `1px solid ${zeplinColor.Neutral6}`,
              display: 'flex',
              gap: '8px',
              // flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Typography variant='responsiveBody3'>Captiv8</Typography>
            <img src='/assets/link-2.svg' className={styles['captiv8Link']} />
          </CustomCard>
        </Link>
      </Box>
    );
  };
  const Column = () => {
    return (
      // <Box
      //   sx={{
      //     // flex: 1,
      //     // display: 'flex',
      //     // flexDirection: 'column',
      //     // justifyContent: 'center',
      //     // alignItems: 'center',
      //     overflowY: 'scroll',
      //   }}
      // >
      captive8loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: { xs: '8rem', xl: '9rem' },
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '27vh'
            //   : screenHeight > 1000
            //   ? '26vh'
            //   : screenHeight > 900
            //   ? '25vh'
            //   : screenHeight > 800
            //   ? '24vh'
            //   : '23vh',
          }}
        >
          {[1].map((val: any, ind: number) => (
            <SocialEngagementCard data={val} index={ind} key={ind} loading={true} />
          ))}
        </Box>
      ) : noData && !captive8loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '27vh'
            //   : screenHeight > 1000
            //   ? '26vh'
            //   : screenHeight > 900
            //   ? '25vh'
            //   : screenHeight > 800
            //   ? '24vh'
            //   : '23vh',
          }}
        >
          {' '}
          <img
            src={'/assets/No-Captive8.svg'}
            className={styles['no-social-engagement']}
            alt='no-social-engagement-found'
          />
          <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
            No Data Found
          </Typography>
          <Typography
            variant='responsiveBody3'
            color={zeplinColor.Neutral8}
            sx={{ textAlign: 'center' }}
          >
            To view this client’s social engagement, please add their unique Creator ID in
            Salesforce. Once updated, the data will appear here automatically if the creator exists
            in Captiv8
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            // overflowY: 'scroll',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            position: 'relative',
            height: { xs: '6rem', xl: '7.5rem' },
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '27vh'
            //   : screenHeight > 1000
            //   ? '16vh'
            //   : screenHeight > 900
            //   ? '25vh'
            //   : screenHeight > 800
            //   ? '24vh'
            //   : '23vh',
          }}
          onClick={() => setValue && setValue(4)}
        >
          {[1].map((val: any, ind: number) => (
            <SocialEngagementCard data={creatorInfo} index={ind} key={ind} />
          ))}
        </Box>
      )
      // </Box>
    );
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
        padding: 0,
        overflow: 'hidden',
      }}
    >
      <Header />
      <Column />
      {/* <Box>
        <Header />
      </Box> */}
      {/* <InfiniteScrollColumn header={<Header />} content={<Column />} height='25vh' /> */}
    </Box>
  );
};

export default SocialEngagement;
